const gradientGenerator = (color1, color2, steps) => {
  let newColor = [];
  let deltaAlphas = [];
  color1.map((alpha, index) => {
    if (alpha < color2[index]) {
      deltaAlphas.push(color2[index] - alpha);
    } else if (alpha > color2[index]) {
      deltaAlphas.push(alpha - color2[index]);
    } else {
      deltaAlphas.push(0);
    }
  });
  let stepAlphas = [];
  deltaAlphas.map((alpha) => {
    stepAlphas.push(alpha / (steps - 1));
  });
  let prevColor = color1;
  newColor.push(color1);
  for (let i = 0; i < steps - 2; i++) {
    let stepColor = [];
    prevColor.map((alpha, index) => {
      if (color1[index] < color2[index]) {
        stepColor.push(prevColor[index] + stepAlphas[index]);
      } else if (color1[index] > color2[index]) {
        stepColor.push(prevColor[index] - stepAlphas[index]);
      } else {
        stepColor.push(prevColor[index]);
      }
    });
    prevColor = stepColor;
    newColor.push(stepColor);
  }
  newColor.push(color2);

  return newColor;
};
export default gradientGenerator;
